// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".university-card[data-v-8390bd40]{transition:.25s!important}.university-card[data-v-8390bd40]:hover{box-shadow:0 4px 25px rgba(0,0,0,.071);transform:translate3d(0,-10px,0)}@media only screen and (max-width:1439px){.university-card[data-v-8390bd40]:hover{box-shadow:none;transform:translateZ(0)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
